// extracted by mini-css-extract-plugin
export default {"_box":"Tooltip__box__9L78w","_popup":"Tooltip__popup__gOhWM","_text":"Tooltip__text__DFWPv","tooltip":"Tooltip_tooltip__lpfFK","tooltip-opacity":"Tooltip_tooltip-opacity__HWl8Q"};